import React, {Component} from 'react';
import * as R from 'ramda';

import TwitterAdShareButton from 'js/campaign_analytics/v2/campaign_analytics_page/posts/share_buttons/twitter_ad_share_button';

class TwitterAdModeSubmissionCTA extends Component {
    render() {
        const {
            isAdmin,
            isSalesUser,
            shareOptions,
            post: {post_id: postId},
            uploading,
            handleShareToTwitterAdManager
        } = this.props;

        if (isAdmin && !isSalesUser) {
            return null;
        }

        const twitterAdShareOptions = R.prop('twitter_ads', shareOptions);

        return (
            <div className="twitter-controls">
                <TwitterAdShareButton
                    disabled={uploading}
                    post_id={postId}
                    share_options={twitterAdShareOptions}
                    isSalesUser={isSalesUser}
                    on_share={handleShareToTwitterAdManager}
                />
            </div>
        );
    }
}

export default TwitterAdModeSubmissionCTA;



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/ad_mode/submission_ctas/twitter.js